module.exports = __webpack_public_path__ + "img/puck-chat.b16ecab8.jpg";